module.exports = __webpack_public_path__ + "static/its-not-how-good-you-are-its-how-good-you-want-to-be-1962f2ae9a8491a0e4e1c794e6d49678.jpg";